<script setup lang="ts">

</script>

<template>
  <div class="impx-menu-cat-group impx-menu-cat-group-carousel">
    <div class="uk-position-relative">
      <!-- Menu group #1 -->
      <ul class="uk-grid uk-child-width-1-3@xl uk-child-width-1-3@l uk-child-width-1-3@m uk-child-width-1-1@s uk-grid-collapse impx-menu-page-2col">
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<style scoped>

</style>